import { Component, OnInit } from '@angular/core';
import { HttpServices } from '../../services/http-services';
import { AlertService } from '../../services/alert.service';
import { PrintTableService } from '../../services/printTableService';
import { LoraTable } from '../../interfaces/lora-table';
import { LocalDataSource } from 'ng2-smart-table';
import { ActivatedRoute } from '@angular/router';
import { DeviceInfoTableHeader } from '../../models/DeviceInfoTableHeader';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'device-info-pages',
  templateUrl: 'device-info.template.html',
  styleUrls: ['device-info.styles.scss']
})

export class DeviceInfoPageComponent implements OnInit {
  noDataString: string = 'Нет данных';
  chartLabels: any = [];
  onFilter: any = false;
  dataDateFrom: any;
  dataDateTo: any;
  deviceInfoTable: LoraTable[] = [];
  error: any;
  blockNav: boolean[] = [true, false, false];
  block: boolean[] = [true, false];
  showLoader: boolean = false;
  euiRequest: any;
  curentDivece: any;
  curentSNDivece: any;
  curentDataDivece: LoraTable = new LoraTable();
  dataGraph = [{ data: [], label: [] }];
  deviceInfoTableHeader = DeviceInfoTableHeader;
  source: LocalDataSource;
  boxAlldev: boolean = false;

  deciceLoraTableDefault: LoraTable[] = [];

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
    sunHighlight: false,
    satHighlight: false
  };

  constructor(private tableHttpReqest: HttpServices,
              private route: ActivatedRoute,
              private alert: AlertService,
              private printtable: PrintTableService) { }

  ngOnInit () {
    this.euiRequest = this.route
      .queryParams
      .subscribe(params => this.curentDivece = params);
      this.deviceRequestFilters(this.curentDivece.euiRequest, false, true);

  }

  deviceRequestFilters(idDevice: string, param: boolean, init: boolean) {
    const dateFrom = this.dataDateFrom && param ? this.dataDateFrom.epoc * 1000 : this.getDefaultDate('f');
    const dateTo = this.dataDateTo && param ? this.dataDateTo.epoc * 1000 : this.getDefaultDate('t');
    this.toDeviceRequest({idDevice, dateFrom, dateTo}, init, this.boxAlldev);
  }

  toDeviceRequest(dataDevice, init, allDevices) {
    this.fetchData();
    this.tableHttpReqest.getDeviceLoraTable(dataDevice.idDevice, dataDevice.dateFrom, dataDevice.dateTo, allDevices).subscribe(
      (data) => {
        this.deviceInfoTable = (data.length > 0) ? data : this.deciceLoraTableDefault;
        this.source = new LocalDataSource(this.deviceInfoTable);
        if (data.length < 1) this.curentDataDivece.id = null;
        this.alert.success('Данные по устройству ' + this.curentDivece.euiRequest + ' загружены');
        if (init) this.curentDataDivece = this.deviceInfoTable[0];
        setTimeout(() => {
          this.showLoader = false;
          }, 300);
        if(this.deviceInfoTable[0]) this.curentSNDivece = this.deviceInfoTable[0].snw;
      },
      error => {
        this.alert.error('Загрузка данных по ' + this.curentDivece.euiRequest + ' не удалась');
        this.error = error;
        console.log(error);
        setTimeout(() => {
          this.showLoader = false;
          }, 300);
        });
  }

  setDataGraph (data, param) {
    const tempLabelGraphic: Array<any> = [];
    const tempDataGraphic: Array<any> = [{ data: [], label: [] }];

    if (param === 1 && this.dataGraph.length > 1) this.dataGraph.pop();

    if (param === 2) { tempDataGraphic.push({ data: [], label: [] });
                       this.dataGraph.push({ data: [], label: [] });
                     }

    data.forEach(item => {

      if (param === 1) { tempLabelGraphic.push(item.modTime);
                         tempDataGraphic[0].data.push(item.dv0);
                         tempDataGraphic[0].label[0] = 'Объем';
                       }

      if (param === 2) { tempLabelGraphic.push(item.modTime);
                         tempDataGraphic[0].data.push(item.rxInfoLoraSnr);
                         tempDataGraphic[0].label = 'SNR';
                         tempDataGraphic[1].data.push(item.rxInfoRssi);
                         tempDataGraphic[1].label = 'RSSI';
                       }
    });
       setTimeout(() => this.chartLabels = tempLabelGraphic);
       setTimeout(() => this.dataGraph = tempDataGraphic);
  }

  getDefaultDate(param) {
    let defaultDate;
    defaultDate = (param === 'f') ? new Date(3600 * 24 * 1000) : new Date();
    return defaultDate;
  }

  getFilterPanel() {
    this.onFilter = !this.onFilter;
  }

  showBlockNav (index, param) {
      this.blockNav = this.blockNav.map((item, i) => i === param);
      this.block = this.block.map((item, i) => i === index);
      this.setDataGraph(this.deviceInfoTable, param);
  }

  fetchData(): void {
    this.showLoader = true;
  }
  changeBox(e: boolean) {
    this.boxAlldev = e;
  }
  print(): void  {
    this.printtable.print('print-section');
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/device-info/divice-info.component.ts